<template>
  <div class="p-4">
    <chart-empty />
  </div>
</template>

<script>
import ChartEmpty from '@/components/ChartEmpty'
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartPoliticiansForEachJurisdiction',
  components: { ChartEmpty }
}
</script>

<csv></csv>
